import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import './App.css';
import About from './components/About/About';
import Portfolio from "./components/Portfolio/Portfolio";
import Resume from "./components/Resume/Resume";
import Contact from "./components/Contact/Contact";
import Blogs from "./components/Blogs/Blogs";


function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
           <About></About>
        </Route>
        <Route path="/about">
           <About></About>
        </Route>
        <Route path="/portfolio">
           <Portfolio></Portfolio>
        </Route>
        <Route path="/blogs">
           <Blogs></Blogs>
        </Route>
        <Route path="/resume">
           <Resume></Resume>
        </Route>
        <Route path="/contact">
           <Contact></Contact>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
